<template>
  <div class="no-results">
    <EMessageTips
      :tips-message="getTranslation('.tips')"
      :tips="tips"
    >
      {{ getTranslation('') }}
      “<strong
        class="no-results__query"
        data-test-id="no-results-query"
      >{{ query }}</strong>”
    </EMessageTips>
    <EButton
      v-if="back"
      as="a"
      size="m"
      :href="backUrl"
      class="no-results__back"
      data-test-id="no-results-back"
    >
      {{ $t('common.pagination.backfirst') }}
    </EButton>
  </div>
</template>

<script>
import EMessageTips from '~~/common/vue/components/message-tips';
import EButton from '~~/common/vue/components/button';

export const tipsCount = 3;

export default {
  name: 'ENoResults',
  components: {
    EButton,
    EMessageTips,
  },
  props: {
    /**
     * If there are no results because of an error
     */
    error: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      required: true,
    },
    back: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translationPrefix() {
      return `common.search.${this.error ? 'error' : 'noresults'}`;
    },
    tips() {
      return Array.from({ length: tipsCount }, (value, index) => this.getTranslation(`.tip${index + 1}`));
    },
    backUrl() {
      const query = { ...this.$route.query, p: undefined };
      const { href } = this.$router.resolve({ query });
      return href;
    },
  },
  methods: {
    getTranslation(part) {
      return this.$t(`${this.translationPrefix}${part}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-results {
  padding: $space-s;

  @include desktop {
    padding: 0 0 $space-s 0;
  }
}

.no-results__query {
  white-space: nowrap;
}

.no-results__back {
  margin-top: $space-s;
}
</style>
